"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.sendContactForm.name': 'Formulario de Contacto',
    'tools.sendContactForm.description': 'Recopila datos del formulario de contacto (nombre, correo electrónico, teléfono, mensaje) de los mensajes del usuario y envía una solicitud de contacto',
};
